import { loadUsersForPartnerRoles, getPartnerRoles } from 'src/services/UserService';
import {
    ROLE_FILTER_KIND,
    parseIdentityRoleIdsFromKeys,
    toSelectedFilterFromKey,
} from 'src/services/userRoleFilterUtils';

export async function loadRoleFilterCatalogs(partnerId) {
    const identityRoles = (await getPartnerRoles(partnerId)) || [];
    return { identityRoles };
}

export function resolveSelectedRoleFilters(selectedKeys, catalogs) {
    return selectedKeys
        .map(key => toSelectedFilterFromKey(key, catalogs))
        .filter(filter => filter != null);
}

function collectRoleIds(selectedKeys, selectedFilters) {
    const roleIdsFromKeys = parseIdentityRoleIdsFromKeys(selectedKeys);
    const roleIdsFromFilters = (selectedFilters || [])
        .filter(filter => filter.kind === ROLE_FILTER_KIND.IDENTITY)
        .map(filter => filter.roleId)
        .filter(Boolean);

    return [...new Set([...roleIdsFromKeys, ...roleIdsFromFilters])];
}

export async function applyPartnerRoleFilters(partnerId, selectedFilters, selectedKeys = []) {
    const roleIds = collectRoleIds(selectedKeys, selectedFilters);
    if (!roleIds.length) {
        return [];
    }

    return loadUsersForPartnerRoles(partnerId, roleIds);
}
